module.exports = __webpack_public_path__ + "static/img/quick-icon-f.900b7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/quick-icon-f.png
// module id = mj2p
// module chunks = 3 5